// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iframe {
    width: 960px;  
    height: 1000px ;
    padding: 0;    
    padding-bottom: 40px ;     
    align-self: center!important;
    border: 1px red solid; overflow-block:hidden ;
}

.toolbar-spacer {
    flex: 1 1 auto;
}

a.title {
    color: white;
}

.app-container {
    padding-left: 3em;
    padding-right: 3em;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,4BAA4B;IAC5B,qBAAqB,EAAE,sBAAsB;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".iframe {\r\n    width: 960px;  \r\n    height: 1000px ;\r\n    padding: 0;    \r\n    padding-bottom: 40px ;     \r\n    align-self: center!important;\r\n    border: 1px red solid; overflow-block:hidden ;\r\n}\r\n\r\n.toolbar-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\na.title {\r\n    color: white;\r\n}\r\n\r\n.app-container {\r\n    padding-left: 3em;\r\n    padding-right: 3em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
